var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import EarlyAlertReasonService from "../../services/EarlyAlertReasonService";
import EarlyAlertReason from "../../models/EarlyAlertReason";
import Busy from "../shared/busy";
import Modal from "../shared/modal";
import Checkbox from "../shared/checkbox";
import DeprecatedSelect from "../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
import RoleService from "../../src/Services/Role.service";
import PersonTypeService from "../../src/Services/PersonType.service";
import ErrorService from "../../src/Services/Shared/Error.service";
import CharacterCounter from "../../src/View/UI/CharacterCounter/CharacterCounter";
const initialState = {
    active: true,
    createIsRestricted: false,
    description: "",
    errors: [],
    isLoading: false,
    isReset: true,
    isSaving: false,
    name: "",
    rolesThatCanViewAlertsWithReason: [],
    rolesThatCanCreateAlertsWithReason: [],
    // @ts-expect-error - TS2322 - Type '{ active: true; createIsRestricted: false; description: string; errors: never[]; isLoading: false; isReset: true; isSaving: false; name: string; rolesThatCanViewAlertsWithReason: never[]; rolesThatCanCreateAlertsWithReason: never[]; personTypesThatCanBeAssignedThisReason: never[]; viewIsRestricted: false; validation...' is not assignable to type 'State'.
    personTypesThatCanBeAssignedThisReason: [],
    viewIsRestricted: false,
    validationErrors: [],
};
const ALERT_REASON_DESCRIPTION_CHARACTER_LIMIT = 600;
export default class EarlyAlertReasonEdit extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = initialState;
        this.fetchReason = () => __awaiter(this, void 0, void 0, function* () {
            try {
                this.setState({ isLoading: true });
                const response = yield EarlyAlertReasonService.fetchReason(this.props.reasonId);
                if (response.success) {
                    this.setState({
                        active: response.data.active,
                        createIsRestricted: response.data.createIsRestricted,
                        description: response.data.description || "",
                        name: response.data.name,
                        rolesThatCanCreateAlertsWithReason: response.data.rolesThatCanCreateAlertsWithReason,
                        rolesThatCanViewAlertsWithReason: response.data.rolesThatCanViewAlertsWithReason,
                        viewIsRestricted: response.data.viewIsRestricted,
                        // @ts-expect-error - TS2345 - Argument of type '{ active: boolean; createIsRestricted: boolean; description: string; name: string; rolesThatCanCreateAlertsWithReason: IDName[]; rolesThatCanViewAlertsWithReason: IDName[]; viewIsRestricted: boolean; personTypesThatCanBeAssignedThisReason: any; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, keyof State> | null) | Pick<...> | null'.
                        personTypesThatCanBeAssignedThisReason: 
                        // @ts-expect-error - TS2339 - Property 'personTypesThatCanBeAssignedThisReason' does not exist on type 'EarlyAlertReason'.
                        response.data.personTypesThatCanBeAssignedThisReason,
                    });
                }
            }
            catch (all) {
                this.setState({
                    errors: [...this.state.errors, ErrorService.getMessageFromError(all)],
                });
            }
            finally {
                this.setState({ isLoading: false });
            }
        });
        this.renderValidationErrors = () => {
            if (!this.state.validationErrors || !this.state.validationErrors.length) {
                return null;
            }
            return (_jsxs("div", { className: "alert alert-warning", children: [_jsx("div", { children: "Please correct the following problems:" }), _jsx("ul", { children: this.state.validationErrors.map((message, index) => (_jsx("li", { children: message }, index))) })] }));
        };
        this.validateForm = () => {
            const validationErrors = [];
            if (!this.state.name) {
                validationErrors.push("Name is required.");
            }
            if (this.state.description.length > ALERT_REASON_DESCRIPTION_CHARACTER_LIMIT) {
                validationErrors.push(`Description must be less than ${ALERT_REASON_DESCRIPTION_CHARACTER_LIMIT} characters.`);
            }
            return validationErrors;
        };
        this.save = () => __awaiter(this, void 0, void 0, function* () {
            try {
                const validationErrors = this.validateForm();
                this.setState({ validationErrors });
                if (validationErrors && validationErrors.length) {
                    return;
                }
                this.setState({ isSaving: true });
                const saveReason = new EarlyAlertReason();
                saveReason.id = this.props.reasonId;
                saveReason.createIsRestricted = this.state.createIsRestricted;
                saveReason.description = this.state.description;
                saveReason.name = this.state.name;
                saveReason.active = this.state.active;
                saveReason.rolesThatCanViewAlertsWithReason = [
                    ...this.state.rolesThatCanViewAlertsWithReason,
                ];
                saveReason.rolesThatCanCreateAlertsWithReason = [
                    ...this.state.rolesThatCanCreateAlertsWithReason,
                ];
                saveReason.viewIsRestricted = this.state.viewIsRestricted;
                saveReason.personTypes = [
                    // @ts-expect-error - TS2339 - Property 'personTypesThatCanBeAssignedThisReason' does not exist on type 'State'.
                    ...this.state.personTypesThatCanBeAssignedThisReason,
                ];
                const response = yield EarlyAlertReasonService.saveReason(saveReason);
                this.setState({ isSaving: false });
                if (response.success) {
                    this.props.onAfterSave();
                }
                else {
                    this.setState({ errors: [...this.state.errors, response.message] });
                }
            }
            catch (all) {
                this.setState({
                    errors: [...this.state.errors, ErrorService.getMessageFromError(all)],
                });
                this.setState({ isSaving: false });
            }
        });
        this.onNameChange = (event) => {
            this.setState({ name: event.target.value });
        };
        this.onDescriptionChange = (event) => {
            this.setState({ description: event.target.value || "" });
        };
        this.onActiveChange = (event) => {
            this.setState({ active: event.target.checked });
        };
        this.onModalClose = () => {
            if (this.props.onModalClose) {
                this.props.onModalClose();
            }
        };
        this.getPersonTypes = (input) => __awaiter(this, void 0, void 0, function* () {
            const response = yield PersonTypeService.searchPersonType();
            return { options: response.data };
        });
        this.getRoles = (input) => __awaiter(this, void 0, void 0, function* () {
            const response = yield RoleService.search({
                name: input,
                isDeleted: false,
            }, { max: 10 });
            return {
                options: response.data,
            };
        });
        this.onRolesThatCanViewAlertsWithReasonChange = (roles) => {
            this.setState({ rolesThatCanViewAlertsWithReason: roles });
        };
        this.onRolesThatCanCreateAlertsWithReasonChange = (roles) => {
            this.setState({ rolesThatCanCreateAlertsWithReason: roles });
        };
        this.onPersonTypesThatCanBeAssignedThisReasonChange = (personTypes) => {
            // @ts-expect-error - TS2345 - Argument of type '{ personTypesThatCanBeAssignedThisReason: IDName[]; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, keyof State> | null) | Pick<...> | null'.
            this.setState({ personTypesThatCanBeAssignedThisReason: personTypes });
        };
        this.onCreateIsRestrictedChange = (event) => {
            this.setState({ createIsRestricted: !event.target.checked });
        };
        this.onViewIsRestrictedChange = (event) => {
            this.setState({ viewIsRestricted: !event.target.checked });
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props.reasonId !== 0) {
            setTimeout(() => this.setState({ isReset: false }), 0);
            if (this.props.reasonId !== prevProps.reasonId) {
                this.fetchReason();
            }
        }
        else if (this.state.isReset === false) {
            setTimeout(() => this.setState(initialState), 0);
        }
    }
    render() {
        return (_jsx("div", { children: _jsx(Modal, { isOpen: this.props.isOpen, modalId: "editReasonModal", onCloseModal: this.onModalClose, children: _jsx("div", { className: "modal-dialog modal-lg", role: "document", children: _jsxs("div", { className: "modal-content", children: [_jsxs("div", { className: "modal-header", children: [_jsx("h4", { className: "modal-title", children: _jsx("span", { className: "js-email-preview-title", children: "New Staff Initiated Alert Reason" }) }), _jsx("button", { type: "button", className: "close", "data-dismiss": "modal", "aria-label": "Close", children: _jsx("span", { "aria-hidden": "true", children: "\u00D7" }) })] }), _jsxs("div", { className: "modal-body", children: [_jsxs("div", { className: "form-group required", children: [_jsx("label", { htmlFor: "earlyAlertReasonName", children: "Name" }), _jsx("input", { id: "earlyAlertReasonName", className: "form-control", type: "text", value: this.state.name, onChange: this.onNameChange, 
                                                // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'boolean | undefined'.
                                                required: this.props.isOpen ? "true" : undefined })] }), _jsx("div", { className: "form-group", children: _jsx(Checkbox, { checked: !this.state.createIsRestricted, onChange: this.onCreateIsRestrictedChange, label: "Everyone with access to staff initiated alerts can create staff initiated alerts with this reason" }) }), this.state.createIsRestricted && (_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "rolesThanCanCreateAlertsWithReason", children: "Roles that can create alerts with this reason" }), _jsx(DeprecatedSelect.Async, { id: "rolesThanCanCreateAlertsWithReason", "aria-label": "Roles that can create alerts with this reason", labelKey: "name", loadOptions: this.getRoles, multi: true, onChange: this.onRolesThatCanCreateAlertsWithReasonChange, value: this.state.rolesThatCanCreateAlertsWithReason, valueKey: "id" })] })), _jsx("div", { className: "form-group", children: _jsx(Checkbox, { checked: !this.state.viewIsRestricted, onChange: this.onViewIsRestrictedChange, label: "Everyone with access to staff initiated alerts can view staff initiated alerts with this reason" }) }), this.state.viewIsRestricted && (_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "rolesThatCanViewAlertsWithReason", children: "Roles that can view alerts with this reason" }), _jsx(DeprecatedSelect.Async, { id: "rolesThatCanViewAlertsWithReason", "aria-label": "Roles that can view alerts with this reason", labelKey: "name", loadOptions: this.getRoles, multi: true, onChange: this.onRolesThatCanViewAlertsWithReasonChange, value: this.state.rolesThatCanViewAlertsWithReason, valueKey: "id" }), _jsx("div", { children: _jsx("small", { children: "If \"Send Email to Students\" is checked and Student is in this list, an email will be sent to the student this alert is for if that student has the student role." }) })] })), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "personTypesThatCanBeAssignedThisReason", children: "Person types that can be assigned this reason" }), _jsx(DeprecatedSelect.Async, { id: "personTypesThatCanBeAssignedThisReason", "aria-label": "Person types that can be assigned this reason", labelKey: "name", loadOptions: this.getPersonTypes, multi: true, onChange: this.onPersonTypesThatCanBeAssignedThisReasonChange, 
                                                // @ts-expect-error - TS2339 - Property 'personTypesThatCanBeAssignedThisReason' does not exist on type 'State'.
                                                value: this.state.personTypesThatCanBeAssignedThisReason, valueKey: "id" })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "reasonDescription", children: "Description" }), _jsx("textarea", { id: "reasonDescription", className: "form-control", value: this.state.description, onChange: this.onDescriptionChange, maxLength: ALERT_REASON_DESCRIPTION_CHARACTER_LIMIT }), _jsx(CharacterCounter, { characters: this.state.description, characterLimit: ALERT_REASON_DESCRIPTION_CHARACTER_LIMIT, customOverMessage: (charactersOver) => `${charactersOver} character${charactersOver === 1 ? "" : "s"} over the description length limit (${ALERT_REASON_DESCRIPTION_CHARACTER_LIMIT})` })] }), _jsx("div", { className: "form-group", children: _jsx(Checkbox, { checked: this.state.active, onChange: this.onActiveChange, label: "Active", helpText: "Marking this as inactive will prohibit all roles from creating an staff initiated alert with this reason" }) }), this.renderValidationErrors()] }), _jsxs("div", { className: "modal-footer", children: [_jsxs("button", { type: "button", className: "btn btn-primary", onClick: this.save, disabled: this.state.isSaving, children: [this.state.isSaving ? (_jsx(Busy, {})) : (_jsx("span", { className: "fa fa-save", "aria-hidden": "true" })), " ", "Save"] }), _jsxs("button", { className: "btn btn-outline-secondary", onClick: this.onModalClose, type: "button", children: [_jsx("span", { className: "fa fa-times", "aria-hidden": "true" }), " Close"] })] })] }) }) }) }));
    }
}
